module.exports = __webpack_public_path__ + "img/ercode.6ae9c431.jpg";